export default __webpack_public_path__ + "img/KamasPerksLogo-01.png";